<template lang="html">
  <button
    class="loading-button"
    :class="[levelClass]"
    :disabled="isLoading || disabled"
    :type="type"
    @click="$emit('click', $event)"
  >
    <span v-visible="!isLoading">
      {{ buttonText }}
    </span>

    <AppSpinner v-if="isLoading" size="16" :color="spinnerColor" />
  </button>
</template>

<script>
import { colors } from '@/constants';
import AppSpinner from '@/components/AppSpinner';

export default {
  name: 'LoadingButton',

  components: {
    AppSpinner,
  },

  props: {
    levelClass: {
      type: String,
      default: 'primary',
    },

    isLoading: {
      type: Boolean,
      default: false,
    },

    buttonText: {
      type: String,
      default: 'Submit',
    },

    type: {
      type: String,
      default: 'submit',
    },

    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      spinnerColor:
        this.levelClass === 'primary'
          ? colors.buttonPrimarySpinner
          : colors.spinner,
    };
  },
};
</script>

<style scoped lang="scss">
.loading-button {
  position: relative;
}
</style>
